var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThyroxyLogoLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-dd70747d-5d67-4147-b749-57937f0442da",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 694.7 411.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".uuid-a77f95f9-09ca-48c7-aae5-bac61c514ce7{fill:#0e1116;}.uuid-0105b73f-6d94-4d30-9cbd-17f5508a119c{fill:#5090bd;}.uuid-9ea05655-7f46-4658-82d7-302ab86139b1{stroke-linecap:round;stroke-linejoin:bevel;stroke-width:4px;}.uuid-9ea05655-7f46-4658-82d7-302ab86139b1,.uuid-d56e3886-e594-4c6c-98fb-4c5f0800bdb3{fill:#96bcd7;stroke:#96bcd7;}.uuid-d56e3886-e594-4c6c-98fb-4c5f0800bdb3{stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-6787d4b0-4610-4d8c-b067-b5bbe2894624"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-a77f95f9-09ca-48c7-aae5-bac61c514ce7",
    d: "m225.3,348.9v-123.2h-23.6v-19.2h67.6v19.2h-23.6v123.2h-20.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-a77f95f9-09ca-48c7-aae5-bac61c514ce7",
    d: "m277.1,348.9v-142.4h20.4v50.8h.4c2.1-3.2,4.7-5.8,7.7-7.9,3-2.1,6.8-3.1,11.5-3.1s5.1.4,7.6,1.3c2.5.9,4.8,2.3,6.8,4.3s3.6,4.6,4.8,7.7c1.2,3.1,1.8,7,1.8,11.5v77.8h-20.4v-70.2c0-3.7-.9-6.7-2.6-8.8-1.7-2.1-4.2-3.2-7.4-3.2s-6.5,1.2-8,3.6c-1.5,2.4-2.2,5.9-2.2,10.4v68.2h-20.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-a77f95f9-09ca-48c7-aae5-bac61c514ce7",
    d: "m346.3,247.5h21.6l14,63.2h.4l13.8-63.2h21l-29.2,119c-1.1,4.5-2.6,8.3-4.5,11.2-1.9,2.9-4.2,5.3-6.7,7.2-2.5,1.9-5.2,3.2-8.1,3.9-2.9.7-5.8,1.1-8.9,1.1h-5.6v-19.2h4.6c2,0,3.7-.3,5.2-.8,1.5-.5,2.8-1.7,4-3.6,1.1-1.9,2.1-4.5,3-7.9.9-3.4,2-8.1,3.2-14.1l-27.8-96.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-a77f95f9-09ca-48c7-aae5-bac61c514ce7",
    d: "m425.3,348.9v-101.4h20.4v10.8c4.1-3.7,8.2-6.7,12.2-8.8,4-2.1,8.9-3.2,14.8-3.2v21.6c-2-.8-4.1-1.2-6.2-1.2s-4.4.4-6.9,1.1c-2.5.7-4.7,2-6.7,3.7-2.1,1.7-3.9,4-5.2,6.8-1.3,2.8-2,6.3-2,10.4v60.2h-20.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0105b73f-6d94-4d30-9cbd-17f5508a119c",
    d: "m480.9,240.1c0-5.7,1-10.8,3-15.2s4.7-8.1,8-11c3.2-2.8,6.8-4.9,10.9-6.4,4.1-1.5,8.2-2.2,12.3-2.2s8.2.7,12.3,2.2c4.1,1.5,7.8,3.6,11.1,6.4,3.2,2.9,5.8,6.6,7.8,11s3,9.5,3,15.2v75.2c0,6-1,11.1-3,15.4-2,4.3-4.6,7.8-7.8,10.6-3.3,2.9-7,5.1-11.1,6.6-4.1,1.5-8.2,2.2-12.3,2.2s-8.2-.7-12.3-2.2c-4.1-1.5-7.7-3.7-10.9-6.6-3.3-2.8-6-6.3-8-10.6-2-4.3-3-9.4-3-15.4v-75.2Zm20.4,75.2c0,4.9,1.4,8.6,4.1,10.9,2.7,2.3,6,3.5,9.7,3.5s7-1.2,9.7-3.5c2.7-2.3,4.1-6,4.1-10.9v-75.2c0-4.9-1.4-8.6-4.1-10.9-2.7-2.3-6-3.5-9.7-3.5s-7,1.2-9.7,3.5c-2.7,2.3-4.1,6-4.1,10.9v75.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0105b73f-6d94-4d30-9cbd-17f5508a119c",
    d: "m555.5,348.9l25-51.8-23.8-49.6h21.6l12.6,28.8,12.6-28.8h21.6l-24.2,49.6,25.4,51.8h-21.6l-13.8-31-13.8,31h-21.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0105b73f-6d94-4d30-9cbd-17f5508a119c",
    d: "m623.9,247.5h21.6l14,63.2h.4l13.8-63.2h21l-29.2,119c-1.1,4.5-2.6,8.3-4.5,11.2-1.9,2.9-4.2,5.3-6.7,7.2-2.5,1.9-5.2,3.2-8.1,3.9-2.9.7-5.8,1.1-8.9,1.1h-5.6v-19.2h4.6c2,0,3.7-.3,5.2-.8,1.5-.5,2.8-1.7,4-3.6,1.1-1.9,2.1-4.5,3-7.9.9-3.4,2-8.1,3.2-14.1l-27.8-96.8Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    id: "uuid-a63fb8fa-c970-4a0e-b64f-0bb78489fa3f",
    className: "uuid-9ea05655-7f46-4658-82d7-302ab86139b1",
    x1: 290.7,
    y1: 66.5,
    x2: 319.9,
    y2: 83.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "uuid-9ba3ab88-066e-4628-879c-58a7204f78b5",
    className: "uuid-9ea05655-7f46-4658-82d7-302ab86139b1",
    x1: 319.9,
    y1: 83.3,
    x2: 367.8,
    y2: 55.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "uuid-e1b86708-909e-46cf-95b0-6646b542a22a",
    className: "uuid-9ea05655-7f46-4658-82d7-302ab86139b1",
    x1: 329.9,
    y1: 89.1,
    x2: 367.8,
    y2: 67.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "uuid-35aca0b7-3469-4608-b027-02771e1635b3",
    className: "uuid-9ea05655-7f46-4658-82d7-302ab86139b1",
    x1: 367.8,
    y1: 55.7,
    x2: 415.7,
    y2: 83.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "uuid-13d77f8e-7caa-4455-9246-d884a1c233f2",
    className: "uuid-9ea05655-7f46-4658-82d7-302ab86139b1",
    x1: 415.7,
    y1: 83.3,
    x2: 415.7,
    y2: 138.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "uuid-397016e6-2ee6-4076-bae6-b7c56b7a81d5",
    className: "uuid-9ea05655-7f46-4658-82d7-302ab86139b1",
    x1: 405.8,
    y1: 89.1,
    x2: 405.8,
    y2: 132.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "uuid-7a955365-f39f-405e-95df-2672baee3141",
    className: "uuid-9ea05655-7f46-4658-82d7-302ab86139b1",
    x1: 415.7,
    y1: 138.7,
    x2: 444.9,
    y2: 155.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "uuid-57d114eb-5065-4014-ab04-83da55bfe194",
    className: "uuid-9ea05655-7f46-4658-82d7-302ab86139b1",
    x1: 415.7,
    y1: 138.7,
    x2: 367.8,
    y2: 166.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "uuid-e6e9f181-ed41-4406-9b81-ba99d227f7c6",
    className: "uuid-9ea05655-7f46-4658-82d7-302ab86139b1",
    x1: 367.8,
    y1: 166.4,
    x2: 367.8,
    y2: 200.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "uuid-cade6d4c-0b5e-4af6-a052-b147644915dd",
    className: "uuid-9ea05655-7f46-4658-82d7-302ab86139b1",
    x1: 367.8,
    y1: 166.4,
    x2: 319.9,
    y2: 138.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "uuid-df2cda55-74e8-470c-a1c8-ddf5a84b9649",
    className: "uuid-9ea05655-7f46-4658-82d7-302ab86139b1",
    x1: 367.8,
    y1: 154.9,
    x2: 329.9,
    y2: 132.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "uuid-d8d4c7d5-8b02-4c7e-b514-2cbffa4d9ef5",
    className: "uuid-9ea05655-7f46-4658-82d7-302ab86139b1",
    x1: 319.9,
    y1: 83.3,
    x2: 319.9,
    y2: 138.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "uuid-eed9d9cc-53c0-4aba-bfa8-405efad6d17e",
    className: "uuid-9ea05655-7f46-4658-82d7-302ab86139b1",
    x1: 463.5,
    y1: 162.9,
    x2: 477.4,
    y2: 162.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    id: "uuid-8553128b-34fb-4847-9329-40122bd7238e",
    className: "uuid-9ea05655-7f46-4658-82d7-302ab86139b1",
    x1: 123.4,
    y1: 235.3,
    x2: 119,
    y2: 242.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "uuid-9dcb52d3-f369-437c-a7df-717150c05fcd",
    className: "uuid-9ea05655-7f46-4658-82d7-302ab86139b1",
    x1: 117.9,
    y1: 233,
    x2: 114.3,
    y2: 239.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "uuid-a22cc82f-4e00-4e0e-948b-c1b254bafff9",
    className: "uuid-9ea05655-7f46-4658-82d7-302ab86139b1",
    x1: 112.4,
    y1: 230.7,
    x2: 109.6,
    y2: 235.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "uuid-440bb132-d42c-47e0-a629-16871f4de758",
    className: "uuid-9ea05655-7f46-4658-82d7-302ab86139b1",
    x1: 106.9,
    y1: 228.5,
    x2: 104.9,
    y2: 232
  }), /*#__PURE__*/React.createElement("line", {
    id: "uuid-4e94b56d-65c4-479c-9966-22679d16ff2c",
    className: "uuid-9ea05655-7f46-4658-82d7-302ab86139b1",
    x1: 101.4,
    y1: 226.2,
    x2: 100.1,
    y2: 228.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "uuid-62d7ad1a-3fc5-4b60-8bf7-44c903ae1432",
    className: "uuid-9ea05655-7f46-4658-82d7-302ab86139b1",
    x1: 95.9,
    y1: 223.9,
    x2: 95.4,
    y2: 224.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "uuid-3a4fbc29-ae4f-4dfd-b208-656b6c3b3dcb",
    className: "uuid-9ea05655-7f46-4658-82d7-302ab86139b1",
    x1: 92.3,
    y1: 222.4,
    x2: 92.3,
    y2: 167.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "uuid-e3b11c7b-9368-4c68-a5e2-709db78e4dd7",
    className: "uuid-9ea05655-7f46-4658-82d7-302ab86139b1",
    x1: 92.3,
    y1: 167.3,
    x2: 140,
    y2: 139.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "uuid-05a81f18-e902-4255-8f2e-944f7976e0e9",
    className: "uuid-9ea05655-7f46-4658-82d7-302ab86139b1",
    x1: 140,
    y1: 139.8,
    x2: 140,
    y2: 84.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "uuid-c43e8087-4d10-4d63-bba8-afdb2fe53d1e",
    className: "uuid-9ea05655-7f46-4658-82d7-302ab86139b1",
    x1: 149.9,
    y1: 134.1,
    x2: 149.9,
    y2: 90.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "uuid-50fe39de-19d4-4784-b9f7-ad4a0f9416c1",
    className: "uuid-9ea05655-7f46-4658-82d7-302ab86139b1",
    x1: 140,
    y1: 84.7,
    x2: 187.7,
    y2: 57.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "uuid-21e5d184-08d6-4857-8d60-18c558f8207f",
    className: "uuid-9ea05655-7f46-4658-82d7-302ab86139b1",
    x1: 187.7,
    y1: 57.2,
    x2: 187.7,
    y2: 23.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "uuid-9d7ab0f2-dc0f-4282-960c-e37f3b32b2ef",
    className: "uuid-9ea05655-7f46-4658-82d7-302ab86139b1",
    x1: 187.7,
    y1: 57.2,
    x2: 235.4,
    y2: 84.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "uuid-7c3e9eb8-6479-4740-8720-844ab36b04e5",
    className: "uuid-9ea05655-7f46-4658-82d7-302ab86139b1",
    x1: 187.7,
    y1: 68.6,
    x2: 225.5,
    y2: 90.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "uuid-5aefc629-1b28-47ec-8de7-77e5b7d482a3",
    className: "uuid-9ea05655-7f46-4658-82d7-302ab86139b1",
    x1: 235.4,
    y1: 84.7,
    x2: 264.4,
    y2: 67.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "uuid-8056b913-68a8-4b76-9e17-85381048a870",
    className: "uuid-9ea05655-7f46-4658-82d7-302ab86139b1",
    x1: 235.4,
    y1: 84.7,
    x2: 235.4,
    y2: 139.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "uuid-b25235a4-bfe4-4093-b271-de72ae2502dd",
    className: "uuid-9ea05655-7f46-4658-82d7-302ab86139b1",
    x1: 235.4,
    y1: 139.8,
    x2: 264.4,
    y2: 156.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "uuid-2066694e-f955-4a11-aabd-2e46fad42833",
    className: "uuid-9ea05655-7f46-4658-82d7-302ab86139b1",
    x1: 235.4,
    y1: 139.8,
    x2: 187.7,
    y2: 167.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "uuid-46fddcaf-45c9-47ef-8688-5cc360ed8204",
    className: "uuid-9ea05655-7f46-4658-82d7-302ab86139b1",
    x1: 225.5,
    y1: 134.1,
    x2: 187.7,
    y2: 155.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "uuid-c9c2d764-4f9f-47dc-8eae-0d82965fc149",
    className: "uuid-9ea05655-7f46-4658-82d7-302ab86139b1",
    x1: 140,
    y1: 139.8,
    x2: 187.7,
    y2: 167.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "uuid-5a831976-78f2-4d12-8953-4fd72779dc41",
    className: "uuid-9ea05655-7f46-4658-82d7-302ab86139b1",
    x1: 92.3,
    y1: 222.4,
    x2: 44.6,
    y2: 249.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "uuid-e9de14a9-5744-42c9-ae08-35152fc23e43",
    className: "uuid-9ea05655-7f46-4658-82d7-302ab86139b1",
    x1: 44.6,
    y1: 249.9,
    x2: 44.6,
    y2: 283.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "uuid-0dbb1183-9576-4e3a-8c5a-98fb626cd83a",
    className: "uuid-9ea05655-7f46-4658-82d7-302ab86139b1",
    x1: 44.6,
    y1: 255.7,
    x2: 13.1,
    y2: 237.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "uuid-1b8be134-4327-468a-a41c-dc9bc3f4114b",
    className: "uuid-9ea05655-7f46-4658-82d7-302ab86139b1",
    x1: 51.6,
    y1: 245.7,
    x2: 20.1,
    y2: 227.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "uuid-fa069193-6969-4468-8562-e3039c7c6cbe",
    className: "uuid-9ea05655-7f46-4658-82d7-302ab86139b1",
    x1: 35.7,
    y1: 306.7,
    x2: 25.5,
    y2: 314.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "uuid-bc4de4ae-ed44-4405-9ea0-2465c3bfdbb5",
    className: "uuid-9ea05655-7f46-4658-82d7-302ab86139b1",
    x1: 140.4,
    y1: 237.9,
    x2: 148.4,
    y2: 232.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "uuid-8d8dca1d-39e3-41a8-9e7b-bcc28c3daac8",
    className: "uuid-9ea05655-7f46-4658-82d7-302ab86139b1",
    x1: 132.4,
    y1: 268.9,
    x2: 132.4,
    y2: 260.9
  })), /*#__PURE__*/React.createElement("path", {
    className: "uuid-d56e3886-e594-4c6c-98fb-4c5f0800bdb3",
    d: "m482.2,168.9v-1.1l1.4-.2v-10.1l-1.4-.2v-1.1h4.6v1.1l-1.4.2v4.4h6.1v-4.4l-1.4-.2v-1.1h4.6v1.1l-1.4.2v10.1l1.4.2v1.1h-4.6v-1.1l1.4-.2v-4.3h-6.1v4.3l1.4.2v1.1h-4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-d56e3886-e594-4c6c-98fb-4c5f0800bdb3",
    d: "m7.2,325.9v-1.1l1.4-.2v-10.1l-1.4-.2v-1.1h4.6v1.1l-1.4.2v4.4h6.1v-4.4l-1.4-.2v-1.1h4.6v1.1l-1.4.2v10.1l1.4.2v1.1h-4.6v-1.1l1.4-.2v-4.3h-6.1v4.3l1.4.2v1.1h-4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-d56e3886-e594-4c6c-98fb-4c5f0800bdb3",
    d: "m126.2,255.9v-1.1l1.4-.2v-10.1l-1.4-.2v-1.1h3.2l6.3,10h0v-8.6l-1.6-.2v-1.1h4.6v1.1l-1.4.2v11.4h-1.6l-6.4-10h0v8.7l1.6.2v1.1h-4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-d56e3886-e594-4c6c-98fb-4c5f0800bdb3",
    d: "m153.2,238.9v-1.1l1.4-.2v-10.1l-1.4-.2v-1.1h4.6v1.1l-1.4.2v4.4h6.1v-4.4l-1.4-.2v-1.1h4.6v1.1l-1.4.2v10.1l1.4.2v1.1h-4.6v-1.1l1.4-.2v-4.3h-6.1v4.3l1.4.2v1.1h-4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-d56e3886-e594-4c6c-98fb-4c5f0800bdb3",
    d: "m126.2,286.9v-1.1l1.4-.2v-10.1l-1.4-.2v-1.1h4.6v1.1l-1.4.2v4.4h6.1v-4.4l-1.4-.2v-1.1h4.6v1.1l-1.4.2v10.1l1.4.2v1.1h-4.6v-1.1l1.4-.2v-4.3h-6.1v4.3l1.4.2v1.1h-4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-d56e3886-e594-4c6c-98fb-4c5f0800bdb3",
    d: "m453.4,169.1c-.8,0-1.6-.2-2.2-.5s-1.2-.8-1.7-1.3c-.5-.6-.8-1.3-1.1-2.1-.2-.8-.4-1.7-.4-2.6v-.2c0-.9.1-1.8.4-2.6.2-.8.6-1.5,1.1-2.1.5-.6,1-1,1.7-1.3s1.4-.5,2.2-.5,1.6.2,2.3.5,1.2.8,1.7,1.3c.4.6.8,1.3,1,2.1s.3,1.7.3,2.6v.2c0,1-.1,1.8-.3,2.6s-.6,1.5-1,2.1c-.4.6-1,1-1.7,1.3s-1.4.5-2.3.5Zm0-1.4c.8,0,1.5-.2,2.1-.6.5-.4.9-1,1.2-1.8s.4-1.6.4-2.6v-.2c0-1-.1-1.9-.4-2.6s-.6-1.3-1.2-1.8-1.2-.6-2-.6-1.4.2-2,.6-.9,1-1.2,1.8-.4,1.6-.4,2.6v.2c0,1,.1,1.9.4,2.6s.7,1.4,1.2,1.8,1.2.6,2,.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-d56e3886-e594-4c6c-98fb-4c5f0800bdb3",
    d: "m278.4,70.1c-.8,0-1.6-.2-2.2-.5s-1.2-.8-1.7-1.3c-.5-.6-.8-1.3-1.1-2.1-.2-.8-.4-1.7-.4-2.6v-.2c0-.9.1-1.8.4-2.6.2-.8.6-1.5,1.1-2.1.5-.6,1-1,1.7-1.3s1.4-.5,2.2-.5,1.6.2,2.3.5,1.2.8,1.7,1.3c.4.6.8,1.3,1,2.1s.3,1.7.3,2.6v.2c0,1-.1,1.8-.3,2.6s-.6,1.5-1,2.1c-.4.6-1,1-1.7,1.3s-1.4.5-2.3.5Zm0-1.4c.8,0,1.5-.2,2.1-.6.5-.4.9-1,1.2-1.8s.4-1.6.4-2.6v-.2c0-1-.1-1.9-.4-2.6s-.6-1.3-1.2-1.8-1.2-.6-2-.6-1.4.2-2,.6-.9,1-1.2,1.8-.4,1.6-.4,2.6v.2c0,1,.1,1.9.4,2.6s.7,1.4,1.2,1.8,1.2.6,2,.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-d56e3886-e594-4c6c-98fb-4c5f0800bdb3",
    d: "m44.4,305.1c-.8,0-1.6-.2-2.2-.5s-1.2-.8-1.7-1.3c-.5-.6-.8-1.3-1.1-2.1-.2-.8-.4-1.7-.4-2.6v-.2c0-.9.1-1.8.4-2.6.2-.8.6-1.5,1.1-2.1.5-.6,1-1,1.7-1.3s1.4-.5,2.2-.5,1.6.2,2.3.5,1.2.8,1.7,1.3c.4.6.8,1.3,1,2.1.2.8.3,1.7.3,2.6v.2c0,1-.1,1.8-.3,2.6s-.6,1.5-1,2.1c-.4.6-1,1-1.7,1.3s-1.4.5-2.3.5Zm0-1.4c.8,0,1.5-.2,2.1-.6.5-.4.9-1,1.2-1.8.2-.8.4-1.6.4-2.6v-.2c0-1-.1-1.9-.4-2.6-.2-.8-.6-1.3-1.2-1.8-.5-.4-1.2-.6-2-.6s-1.4.2-2,.6-.9,1-1.2,1.8c-.3.8-.4,1.6-.4,2.6v.2c0,1,.1,1.9.4,2.6.3.8.7,1.4,1.2,1.8.5.4,1.2.6,2,.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-d56e3886-e594-4c6c-98fb-4c5f0800bdb3",
    d: "m6.4,233.1c-.8,0-1.6-.2-2.2-.5s-1.2-.8-1.7-1.3c-.5-.6-.8-1.3-1.1-2.1-.2-.8-.4-1.7-.4-2.6v-.2c0-.9.1-1.8.4-2.6.2-.8.6-1.5,1.1-2.1.5-.6,1-1,1.7-1.3s1.4-.5,2.2-.5,1.6.2,2.3.5,1.2.8,1.7,1.3c.4.6.8,1.3,1,2.1s.3,1.7.3,2.6v.2c0,1-.1,1.8-.3,2.6s-.6,1.5-1,2.1c-.4.6-1,1-1.7,1.3s-1.4.5-2.3.5Zm0-1.4c.8,0,1.5-.2,2.1-.6.5-.4.9-1,1.2-1.8s.4-1.6.4-2.6v-.2c0-1-.1-1.9-.4-2.6s-.6-1.3-1.2-1.8-1.2-.6-2-.6-1.4.2-2,.6-.9,1-1.2,1.8-.4,1.6-.4,2.6v.2c0,1,.1,1.9.4,2.6s.7,1.4,1.2,1.8,1.2.6,2,.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-d56e3886-e594-4c6c-98fb-4c5f0800bdb3",
    d: "m365.2,219.9v-1.1l1.4-.2v-10.1l-1.4-.2v-1.1h4.6v1.1l-1.4.2v10.1l1.4.2v1.1h-4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-d56e3886-e594-4c6c-98fb-4c5f0800bdb3",
    d: "m271.2,168.9v-1.1l1.4-.2v-10.1l-1.4-.2v-1.1h4.6v1.1l-1.4.2v10.1l1.4.2v1.1h-4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-d56e3886-e594-4c6c-98fb-4c5f0800bdb3",
    d: "m185.2,15.9v-1.1l1.4-.2V4.5l-1.4-.2v-1.1h4.6v1.1l-1.4.2v10.1l1.4.2v1.1h-4.6Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThyroxyLogoLight);
export default __webpack_public_path__ + "static/media/thyroxy-logo-light.9c40ad5f0f5cb907234e9195ae03e920.svg";
export { ForwardRef as ReactComponent };